export const convertJSONToQueryString = (obj: any): string => {
  return Object.keys(obj)
    .filter((key: string) => obj[key] != null)
    .map((key: string) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&");
};
